var exports = {
  "Ui": "diff__GZFl4M",
  "RV": "diffTargetable__jbrCub",
  "SN": "diffHeaderWrapper__INiK1j",
  "OS": "diffHeaderWrapperWithMiniHeaderAndToolbar__PcL4HR",
  "jY": "diffAddFileThread__iLUm9m",
  "pu": "diffFooter__nC3T_E",
  "E4": "hideOnNarrowContainer__pY4d8E",
};

module.exports = exports;
